module.exports = __webpack_public_path__ + "static/media/p8.e71ae214.webp";